import { render, staticRenderFns } from "./NotifyUsers.vue?vue&type=template&id=997a5b2e&"
import script from "./NotifyUsers.vue?vue&type=script&lang=js&"
export * from "./NotifyUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports